import React from "react";
import { arrayOf, string, shape, object } from "prop-types";
import ArrowLink from "../ArrowLink/ArrowLink.jsx";

const propTypes = {
  granteeReportText: string.isRequired,
  granteeWebsiteText: string.isRequired,
  items: arrayOf(
    shape({
      title: string,
      summary: string,
      image: shape({ src: string, alt: string }),
      information: arrayOf(string),
      reportLink: shape({
        url: string,
        text: string,
        target: string,
      }),
      websiteLink: shape({
        url: string,
        text: string,
        target: string,
      }),
    }),
  ),
  focusRef: object,
};

const GranteeListing = (props) => {
  const { items, granteeWebsiteText, granteeReportText, focusRef } = props;
  return (
    <section className="grantee-listing component">
      <ul className="grantee-listing__list">
        {items.map((item, i) => (
          <li className="grantee-listing__item" key={i}>
            {item.image && (
              <div className="grantee-listing__image">
                {item.image && (
                  <img alt={item.image.alt} src={item.image.src} />
                )}
              </div>
            )}
            {(item.title || item.description || item.granteeInformation) && (
              <div className="grantee-listing__content">
                {item.title && (
                  <div
                    className="grantee-listing__item-title"
                    tabIndex="-1"
                    ref={i === 0 ? focusRef : null}
                  >
                    {item.title}
                  </div>
                )}
                {item.summary && (
                  <div className="grantee-listing__item-summary">
                    {item.summary}
                  </div>
                )}
                {item.information && (
                  <div className="grantee-listing__item-grantee-information">
                    {item.information.map((info, i, arr) => (
                      <span key={i}>
                        <span>{info}</span>
                        {arr.length - 1 !== i ? (
                          <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                        ) : null}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}
            {(item.websiteLink || item.reportLink) && (
              <div className="grantee-listing__ctas">
                {item.reportLink && (
                  <div className="grantee-listing__btn-wrapper">
                    <a
                      className="btn btn--primary btn--large"
                      href={item.reportLink.url}
                      data-gtm-element="grantee listing report link"
                      data-gtm-link={item.reportLink.url}
                      data-gtm-text={granteeReportText}
                    >
                      {granteeReportText}
                    </a>
                  </div>
                )}
                {item.websiteLink && (
                  <div className="grantee-listing__link-wrapper">
                    <ArrowLink
                      text={granteeWebsiteText}
                      href={item.websiteLink.url}
                      gtmElementLabel="grantee listing website link"
                    />
                  </div>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

GranteeListing.propTypes = propTypes;
export default GranteeListing;
